import { useEffect } from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";

import useQuery from "../../hooks/useQuery";

import CollectionRoutes from "../collection";

import CollectionPage from "../../pages/collection";

const ShopRoutes = () => {
  const query = useQuery();
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={path}>
        {query.has("brandId") ? (
          /* Brand Page Needed */
          <CollectionRoutes />
        ) : query.has("collectionId") || query.has("productId") ? (
          <CollectionRoutes />
        ) : (
          <Redirect to="/" />
        )}
      </Route>
    </Switch>
  );
};

export default ShopRoutes;
